import React from "react";

/** Bootstrap row wrapper. */
const Row = ({ className = "", style, children, ...rest }) => {
  const cls = ["row", className].filter(Boolean).join(" ");
  return (
    <div className={cls} style={style} {...rest}>
      {children}
    </div>
  );
};

export default Row;
